import { render, staticRenderFns } from "./BlocTabs.vue?vue&type=template&id=31d1e398"
import script from "./BlocTabs.vue?vue&type=script&lang=js"
export * from "./BlocTabs.vue?vue&type=script&lang=js"
import style0 from "./BlocTabs.vue?vue&type=style&index=0&id=31d1e398&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports